import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-channel-side-panel',
  standalone: false,
  templateUrl: './channel-side-panel.component.html',
  styleUrls: ['./channel-side-panel.component.scss'],
})
export class ChannelSidePanelComponent {
  @Input() channel: any;
}